import PageFooter from "../../shared/app-shell/PageFooter";
import { themeAtom } from "../../shared/atoms";
import LoadingWrapper from "../../shared/components/LoadingWrapper";
import { api, apiUrl } from "../../shared/services/service";
import { useAtomValue } from "jotai";
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { twMerge } from "tailwind-merge";

const PreviousCargo = () => {
  const theme = useAtomValue(themeAtom);

  const { imoNumber, vesselCode, vesselName } = useParams();

  const [isLoading, setIsLoading] = useState(false);
  const [previousCargoData, setPreviousCargoData] = useState<any[]>([]);

  const fetchData = async () => {
    try {
      setIsLoading(true);
      const result = await api.get(`${apiUrl}/prev_cargo`, {
        params: {
          imo_no: imoNumber,
          vessel_code: vesselCode,
          vessel_name: vesselName,
        },
      });
      setPreviousCargoData(result.data);
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <LoadingWrapper isLoading={isLoading} loadingIndicatorClassName="text-green" loadingIndicatorSize="lg">
      <div>
        <div
          className={twMerge(
            "mb-4 rounded-lg p-4 shadow-md",
            theme.home.tailwind.panelBackground,
            theme.home.tailwind.textDefault,
          )}
        >
          <h1 className="mb-1 pb-2 text-lg font-bold">Cargoes with Cargill</h1>
          {previousCargoData.length > 0 && (
            <div className="overflow-x-auto">
              <table className="min-w-full">
                <thead>
                  <tr className={twMerge("border", theme.uwhcAssistant.border)}>
                    <th className="h-14 px-4 py-2 text-left text-xs font-semibold">#</th>
                    <th className="h-14 px-4 py-2 text-left text-xs font-semibold">CHARTERER</th>
                    <th className="h-14 px-4 py-2 text-left text-xs font-semibold">TC Codes</th>
                    <th className="h-14 px-4 py-2 text-left text-xs font-semibold">CARGO</th>
                    <th className="h-14 px-4 py-2 text-left text-xs font-semibold">LOAD PORT</th>
                    <th className="h-14 px-4 py-2 text-left text-xs font-semibold">DISCHARGE PORT</th>
                  </tr>
                </thead>
                <tbody>
                  {previousCargoData.map((row, rowIndex) => (
                    <tr key={rowIndex} className={twMerge("border", theme.uwhcAssistant.border)}>
                      <td className="h-14 px-4 py-2 text-xs">{rowIndex + 1}</td>
                      <td className="h-14 px-4 py-2 text-xs">{row.CHARTERER}</td>
                      <td className="h-14 px-4 py-2 text-xs">
                        <Link
                          className={twMerge(
                            "inline-flex items-center justify-center text-sm font-normal",
                            theme.vesselDetails.linkText,
                          )}
                          to={`/voyage/${row.TC_CODE}`}
                        >
                          <p className={twMerge("cursor-pointer leading-5", theme.myVesselsTableRow.row.hover)}>
                            {row.TC_CODE}
                          </p>
                        </Link>
                      </td>
                      <td className="h-14 px-4 py-2 text-xs">{row.CARGO}</td>
                      <td className="h-14 px-4 py-2 text-xs">{row.LOAD_PORT}</td>
                      <td className="h-14 px-4 py-2 text-xs">{row.DISCHARGE_PORT}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
        <div
          className={twMerge(
            "mb-4 rounded-lg p-4 shadow-md",
            theme.home.tailwind.panelBackground,
            theme.home.tailwind.textDefault,
          )}
        >
          <h1 className="mb-1 pb-2 text-lg font-bold">Cargoes Before Cargill</h1>
          No data Available
        </div>

        <PageFooter />
      </div>
    </LoadingWrapper>
  );
};

export default PreviousCargo;
